import {About, CryptoSlider, DownloadApp, Hero, HowItWork, MarketList} from "../../containers";

function MainScreen () {
    return (
      <>
          <Hero/>
          <CryptoSlider/>
          <MarketList/>
          <HowItWork/>
          <About/>
          <DownloadApp/>
      </>
    );
}

export { MainScreen };
